module.exports = __webpack_public_path__ + "9944b9b1bb1921998836b535693e8619.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-1024.webp
// module id = 196
// module chunks = 0